module.exports = __webpack_public_path__ + "static/IMG-20200814-WA0016-fa2bf52b75e06de5c5756b6c25e771a8.jpg";